import { useSelector } from 'react-redux';

/**
 * usePermission(key)
 * Returns true if the current user has the given permission key.
 *
 * Usage:
 *   const canDelete = usePermission('clients.delete');
 */
export function usePermission(key) {
  const data = useSelector((state) => state.permissions.data);
  return data[key] === true;
}

/**
 * usePermissions(keys)
 * Returns an object mapping each key to its boolean value.
 *
 * Usage:
 *   const perms = usePermissions(['clients.view', 'clients.add']);
 *   if (perms['clients.add']) { ... }
 */
export function usePermissions(keys) {
  const data = useSelector((state) => state.permissions.data);
  return keys.reduce((acc, key) => {
    acc[key] = data[key] === true;
    return acc;
  }, {});
}

/**
 * usePermissionsLoaded()
 * Returns true once permissions have been fetched successfully.
 * Useful when you need to gate rendering on the permissions being ready.
 */
export function usePermissionsLoaded() {
  return useSelector((state) => state.permissions.loaded);
}
